import { ChangeDetectorRef, Component, ElementRef, HostListener, NgZone, ViewChild, ViewEncapsulation } from '@angular/core';
import { DistributionDataService } from '../../../services/distributionData.service';
import { PoolingPortalService } from '../../../services/pooling-portal.service';
import { FiltersService } from '../../../services/filters.service';
import { UsersService } from '../../../services/users.service';
import { VesselsService } from '../../../services/vessels.service';
import { Distribution, LatestMonthYear, Filters, EmailRequest } from '../../../interface/distribution.interface';
import { debounceTime, fromEvent, Subscription } from 'rxjs';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NegativeToBracketPipe } from '../../../pipes/negativeToBracket.pipe';
import { GoogleAnaylticsService } from 'src/app/services/google-anayltics.service';
import { GoogleAnalyticsEvents, GoogleAnalyticsModules, GoogleAnalyticsDownloadTypes, SHOW_BANNER_START_DAY, CALCULATION_SCHEDULE_DAY} from '../utils/constants';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-distribution',
  templateUrl: './distribution.component.html',
  styleUrls: ['./distribution.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DistributionComponent {
  GoogleAnalyticsEvents = GoogleAnalyticsEvents;
  GoogleAnalyticsModules = GoogleAnalyticsModules;
  GoogleAnalyticsDownloadTypes = GoogleAnalyticsDownloadTypes;

  monthNameArray = this._poolingPortalService.getMonthShortNames();
  subscription: Subscription;

  distribution: Distribution = {
    //date: new Date(),
    minDate: new Date(),
    maxDate: new Date(),
    distributionData: [],
    allDistributionData: [],
    load: false,
    allSelect: false,
    isSkelton: false,
    shipOwner: [],
    ship: [],
    subpool: [],
    vslClass: [],
    preSelected: [],
    vessels: [],
    owners: [],
    download: true,
    opDaysEditable: false,
    selectDate: {
      month: 0,
      year: 0
    },
    selectMonth: 0,
    selectYear: 0,
    iRole: 0,
    sortBy: 'revenueAmt',
    sortValue: 'desc',
    table: '',
    fleet: '',
    opDaysYtdData: []
  }

  latestData: LatestMonthYear = {
    lastMonth: 0,
    lastUpdatedAt: new Date(),
    lastYear: 0,
    latestMonth: 0,
    latestYear: 0
  }

  filters: Filters = {
    ship: [],
    shipOwners: [],
    vslClass: [],
    subpool: [],
    vslNumber: [],
  }
  shipNames: any = [];
  subPools: any = [];
  shipOwners: any = [];
  vslClasses: any = [];
  open: boolean = false
  offHire: boolean = false;

  shipPools: any = [];
  dragStartindex: number | null = null;
  distributionModalData: any = [];
  resetHeaderconfig: any = [];
  emailRequset: EmailRequest = { email: '' };
  distributionColData: any = [];
  storeDistributionModalData: any = [];
  userEmailid: any;
  userId: any;
  updateModaldata: any = [];
  storeCheckedvalue: any = [];
  resetToDefault: boolean = false;
  toggleDisabled: boolean = false;
  tableHeaderdata: any = [];
  // totalDistAmtYTD: any;
  // totalgrossAmtYTD: any;
  // totalopDaysYTD: any;
  // totalpoolInYTD: any;
  // totalpoolPointYTD: any;
  // totalrelShareYTD: any;
  // totalgrossShareInPoolYTD: any;
  // totalpoolOutYTD: any;
  // totaloverheadAmtYTD: any;
  // totalcommissionAmtYTD: any;
  // totalbunkerYTD: any;
  // totalmgmtFeesYTD: any;
  // totalnetPoolOutYTD: any;
  // netPoolOutPerOpdaysAmtYTD: any;
  // profitSharingContrAmtYTD: any;
  // finalPayout: any;
  grandTotalValues: { [key: string]: any } = {};
  getVesselDistributionData: any = [];
  getSelectedvalues: any = [];
  allFilterOptions: any = [];
  filteredShipPools: any = [];
  enableApplybtn: boolean = false;
  toggleVal: string = '';
  getHiringMonth: any = [];
  offhiringCurrentMonth: any;
  offHiringPreviousMonth: any;
  latestYear: number;
  latestMonth: number;
  offHireData: any = [];
  offHireShipName: string = '';
  columnHeader = [{'name':'No.', 'width': '58px'},
                  {'name':'From', 'width': '144px'},
                  {'name':'To', 'width': '144px'},
                  {'name':'Duration (days)', 'width': '152px'},
                  {'name':'Reason', 'width': '367px'},
                  {'name':'Remarks', 'width': '367px'}];
  defaultActive: boolean;
  showDownloadFilter: boolean = false;
  completeGrandTotalValues: {};
  defaultGrandTotalValues: {};
  defaultGrandtotalset: boolean = false;
  newtableHeaderdata: any = [];
  selectedPagetab: string = 'dist';
  showScrubbertab: boolean = false;
  showDropdown: boolean = false;
  head: any = [];
  body: any = [];
  getScrubberDatalist: any = [];
  filterdScrubberList: any = [];
  worksheet: any;
  dateSelected: any;
  toggleValueChange: any;
  calculationResponse: any = [];
  isCalculationOpen: boolean = false;
  calculationSidePanelHeaderName: string = '';
  calculationDate: Date;
  showBannerToggleDisplay: any;
  //currentDate: string;
  getBannerlastRunDate: any;
  showBannerToggleVal: boolean = false;
  previousMonth: string;
  //currentYear: number;
  showBannerToggleval_: boolean = false;
  toolTipConfig: {
    width: "auto"
  }
  showFinalPayout: boolean = false;
  isDragging: boolean = false;
  checkColumnLength: any = [];
  isPenaltyCurrentMonth: any;
  hasPoolPointUpdateinCurrentMonth: any;
  isPenaltyPreviousMonth: any;
  poolPointsModel: boolean = false;
  poolPointscolumnHeader = [{'name':'No.', 'width': '58px'},
                  {'name':'From', 'width': '144px'},
                  {'name':'To', 'width': '144px'},
                  {'name':'Duration (days)', 'width': '156px'},
                  {'name':'Type', 'width': '264px'},
                  {'name':'Reason/details', 'width': '466px'}];
  poolPointShipName: any;
  poolPointsData: any = [];
  getLngDatalist: any = [];
  filterdLngList: any = [];
  showLNGtab: boolean = false;
  hideDefaultUsersettigs: boolean = false;
  ownersLabel: any;

  private resizeListner: () => void;
  private resizeSubscription!: Subscription
  isScrolled: boolean = false;
  @ViewChild('distTable',{static:false}) distTableRef!: ElementRef<HTMLElement>;
  @ViewChild('showTableHeder') showTableHeaderRef!: ElementRef<HTMLElement>;
  @ViewChild('externalScroll') externalScrollRef!: ElementRef<HTMLElement>;
  private isSyncingScroll = false;
  calcDistributionColDataLength: any;
  tableScrollWidth = 0;
  ticking: boolean = false;
  offsetWidth: number;
  showOverHeadScrubberLNGVoyage: boolean = false;
  showVisibleHaeders: any  = [];
  showBaseHeaders: any = [];
  scrollTimeout: any;
  isHeaderScrolling: boolean = false;
  constructor(
    private _distributionDataService: DistributionDataService,
    private _poolingPortalService: PoolingPortalService,
    private _filterService: FiltersService,
    private _usersService: UsersService,
    private _vesselsService: VesselsService,
    private toasterService: ToasterService,
    private cdr: ChangeDetectorRef,
    private negativeToBracket: NegativeToBracketPipe,
    private zone: NgZone,
    private _googleAnaylticsService: GoogleAnaylticsService
  ) {
  //   this.zone.runOutsideAngular(() => {
  //   requestAnimationFrame(() => {
  //     setTimeout(() => {
  //     this.onWindowScroll = throttle(this.onWindowScroll.bind(this),400);
  //     }, 50); 
  //   });
  // });
    
    
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
  if (!this.ticking) {
    window.requestAnimationFrame(() => {
      this.updateScrollState();
      this.ticking = false;
    });
    this.ticking = true;
  }
}
updateScrollState() {
  const scrollY =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0;
  const newIsScrolled = scrollY > 400;
  if (this.isScrolled !== newIsScrolled) {
    this.isScrolled = newIsScrolled;
    this.cdr.detectChanges(); 
  }
}

  
  ngOnInit() {
    document.body.style.overflow = 'auto';
    // zoom in out issue solving code start
    this.zone.runOutsideAngular(() => {
      this.resizeListner = () => { 
        this.cdr.detach(); //stop detect changes
      }

      this.resizeSubscription = fromEvent(window, 'resize')
      .pipe(debounceTime(100))// wait for 100 ms
      .subscribe(() => {
        this.zone.run(() => {
          this.getTableOffsetWidth()
          this.cdr.reattach(); //start detect changes
        })
      })

    }); 
    window.addEventListener('resize',this.resizeListner);   
    // zoom in out issue solving code end

    this.distribution.isSkelton = true;

    let filters = ['ship', 'shipOwners', 'subpool', 'vslClass', 'vslNumber'];
    filters.forEach((it: any) => {
      this.filters[it] = [];
    });
    this.subscription = this._poolingPortalService.fleet$.subscribe(
      fleet => {
        this.distribution.isSkelton = true;
        this.distribution.load = false;
        this.distribution.fleet = fleet;
        this.selectedPagetab = 'dist';
        // this.clickTab('dist'); //on fleet change redirect to distribution tab
        this.getOwnerList();
        this.getDistributionLatestData();
        this.resetAll();
        this._vesselsService.getShowScrubberLNG(fleet).subscribe({
          next: (res: any) => {;
            if(res?.data?.showScrubberLNG?.success){
              this.showScrubbertab = res?.data?.showScrubberLNG?.data?.showScrubberSavings;
              this.showLNGtab = res?.data?.showScrubberLNG?.data?.showLNGSavings;
            }
          }
        });
        
      }
    )
    this._distributionDataService.changeToggle.subscribe((res: any) => {
      if (res) {
        this.applyModalUpdataData();
      }
    })    
  }
  
  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.getTableOffsetWidth()
    // }, 5000);
    
    this.zone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          this.setScrollWidth();
        }, 50); 
      });
    });

    
   
  }
 
setScrollWidth() {
  const table = this.distTableRef?.nativeElement;
  if (table) {
    const scrollWidth = table.scrollWidth
    this.tableScrollWidth = scrollWidth;
  }
}
getTableOffsetWidth(): number | null {
  const table = this.distTableRef?.nativeElement;
  if (table) {
    this.offsetWidth = table.offsetWidth;
    this.tableScrollWidth = table.scrollWidth;
    return this.offsetWidth && this.tableScrollWidth;
  } else {
    return null;
  }
}
  onHorizontalScroll(source: 'body' | 'outerScroll' | 'header' = 'body') {

  if (this.isSyncingScroll) return;
  this.isSyncingScroll = true;
  const distTable = this.distTableRef?.nativeElement;
  const showHeader = this.showTableHeaderRef?.nativeElement;
  const externalScroll = this.externalScrollRef?.nativeElement;
  if (distTable && externalScroll) {
    switch (source) {
      case 'body':
        if (showHeader) showHeader.scrollLeft = distTable.scrollLeft;
        externalScroll.scrollLeft = distTable.scrollLeft;
        break;
      case 'header':
        distTable.scrollLeft = showHeader?.scrollLeft ?? 0;
        externalScroll.scrollLeft = showHeader?.scrollLeft ?? 0;
        break;
      case 'outerScroll':
        distTable.scrollLeft = externalScroll.scrollLeft;
        if (showHeader) showHeader.scrollLeft = externalScroll.scrollLeft;
        break;
    }
    let scrollLeftValue = 0;
    if (source === 'body') scrollLeftValue = distTable.scrollLeft;
    else if (source === 'header') scrollLeftValue = showHeader?.scrollLeft ?? 0;
    else if (source === 'outerScroll') scrollLeftValue = externalScroll.scrollLeft;
    this.isHeaderScrolling = scrollLeftValue !== 0;
  }
  
  requestAnimationFrame(() => {
    this.isSyncingScroll = false;
  });


  }

//   onHorizontalScroll(source: 'body' | 'outerScroll' | 'header' = 'body') {
//   if (this.isSyncingScroll) return;
 
//   const distTable = this.distTableRef?.nativeElement;
//   const showHeader = this.showTableHeaderRef?.nativeElement;
//   const externalScroll = this.externalScrollRef?.nativeElement;
 
//   if (!distTable || !externalScroll) return;
 
//   this.isSyncingScroll = true;
 
//   requestAnimationFrame(() => {
//     switch (source) {
//       case 'body':
//         if (showHeader) {
//           showHeader.scrollLeft = distTable.scrollLeft;
//         }
//         externalScroll.scrollLeft = distTable.scrollLeft;
//         break;
 
//       case 'header':
//         distTable.scrollLeft = showHeader?.scrollLeft ?? 0;
//         externalScroll.scrollLeft = showHeader?.scrollLeft ?? 0;
//         break;
 
//       case 'outerScroll':
//         distTable.scrollLeft = externalScroll.scrollLeft;
//         if (showHeader) {
//           showHeader.scrollLeft = externalScroll.scrollLeft;
//         }
//         break;
//     }
 
//     this.isSyncingScroll = false;
//   });
// }
 

 
  getOwnerList() {
    this._distributionDataService.getOwnerList(this.distribution.fleet)
      .subscribe({
        next: (res: any) => {
          this.distribution.owners = res.data.getOwnersList.data.map((items: any) => ({ id: items?.value, name: items.label }))
          this.distribution.shipOwner = this._filterService.shipOwners(this.distribution.allDistributionData, this.filters, this.distribution.owners);
          this.ownersLabel = this.distribution.owners.reduce((op,inp)=>{
            let key = inp.id
            let value = inp.name
            op[key] = value
            return op
          },{})
        }
      });
  }

  getDistributionLatestData() {
    let formData = { "fleet": this.distribution.fleet };
    this._distributionDataService.getDistributionLatestData(formData)
      .subscribe({
        next: (res: any) => {
          if (res.data.getLatestMonthAndYear.success) {
            this.latestData = res.data.getLatestMonthAndYear.data;
            this.distribution.selectDate = { month: this.latestData.latestMonth, year: this.latestData.latestYear }
            /* let tempDate = (this.latestData.latestYear && this.latestData.latestMonth) ? new Date(this.latestData.latestYear + '-' + this.latestData.latestMonth.toString().padStart(2, "0")).toISOString() : new Date().toISOString()
            console.log(tempDate)            
            console.log(new Date(Date.UTC(this.latestData.latestYear, this.latestData.latestMonth-1)))
            //this.distribution.maxDate = new Date(Date.UTC(this.latestData.latestYear, this.latestData.latestMonth))
            //this.distribution.maxDate = (this.latestData.latestYear && this.latestData.latestMonth) ? new Date(this.latestData.latestYear + '-' + this.latestData.latestMonth.toString().padStart(2, "0")) : new Date();
            this.distribution.minDate = new Date((this.latestData.lastYear && this.latestData.lastMonth) ? new Date(this.latestData.lastYear + '-' + this.latestData.lastMonth.toString().padStart(2, "0")).toISOString() : new Date().toISOString());
            */
            this.distribution.minDate = new Date(this.latestData.lastYear, this.latestData.lastMonth - 1, 1);
            this.distribution.maxDate = new Date(this.latestData.latestYear, this.latestData.latestMonth - 1, 1);
            console.log('minDate', this.distribution.minDate)
            console.log('maxDate', this.distribution.maxDate)
            this.getDistributionVessel(this.latestData.latestYear, this.latestData.latestMonth);
           
            this._distributionDataService.setSelectedMonthYearVal(this.distribution.maxDate);
            sessionStorage.setItem('fiscalYearStartDate',res.data.getLatestMonthAndYear.data?.fiscalYearStartDate);
            setTimeout(() => {
              //  this.getModaldata();
              this.showBannertoggle();
            }, 3000);
          }
        }
      });
  }
  getDistributionVessel(latestYear: number, latestMonth: number) {
    this.filteredShipPools = [];
    this.shipPools = [];
    this.latestYear = latestYear;
    this.latestMonth = latestMonth;
    let formData = {
      "month": latestMonth,
      "year": latestYear,
      "fleet": this.distribution.fleet
    };
    // this.getModaldata();
    this._distributionDataService.getDistributionVessel(formData)
      .subscribe({
        next: (res) => {
          if (res.data.getDistributionVessel.success) {
            this.distribution.isSkelton = false;
            this.distribution.selectYear = latestYear;
            this.distribution.selectMonth = latestMonth;
            this.getHiringMonth = res.data.getDistributionVessel;
            this.getVesselDistributionData = res.data.getDistributionVessel.distributionVessel;
            this.distribution.allDistributionData = res.data.getDistributionVessel.distributionVessel?.map((items: any) => items?.vesselsMonthlyData).flat();
            this.shipPools = this.getVesselDistributionData;
            this._distributionDataService.getMonth = latestMonth;
            this._distributionDataService.getYear = latestYear;
            /* if (this.shipPools?.some((items: any) => items?.showScrubberSavings)) {
              this.showScrubbertab = true;
              this.selectedPagetab = 'dist';
            } else {
              this.showScrubbertab = false;
              this.selectedPagetab = 'dist';
            } */
            this.distribution.distributionData = this._filterService.filterItems(this.distribution.allDistributionData, this.filters);
            this.refreshDropdownData();
            // this.distribution.distributionData.sort(this.compareValues(this.distribution.sortBy, this.distribution.sortValue));
            this.distribution.load = true;

            // ----commemnt this code as it is already calling in getmodalData()---
            // this.applyFilters();

            //  this.getModaldata();
           
            if(this.hideDefaultUsersettigs){
              this.getModalDataDateChange()
            }else{
              this.getModaldata();
              this.zone.runOutsideAngular(() => {
              requestAnimationFrame(() => {
                setTimeout(() => {
                  this.setScrollWidth();
                }, 50); // wait 1 more frame after paint
              });
            });
            // setTimeout(() => {
            //   this.setScrollWidth();
            // });
            }
          }
          else {
            this.distribution.isSkelton = false;
            this.distribution.load = true;
            this.distribution.allDistributionData = [];
            this.distribution.distributionData = [];
            this.refreshDropdownData();
          }
        },
        error: (error) => {
          this.distribution.isSkelton = false;
        }
      });
  }
  public selectedValues(event: any, field: string) {
    this.filters[field] = event;
    this.getSelectedvalues = event?.selectedRecords;
    this.filters['vslNumber'] = [];
    this.refreshDropdownData();
    this.distribution.distributionData = this._filterService.filterItems(this.distribution.allDistributionData, this.filters);
    
    if (field === 'ship') {
      this.shipNames = this.filters[field]?.map((items: any) => ({ id: items, name: items }))
    } else if (field === 'subpool') {
      this.subPools = this.filters[field]?.map((items: any) => ({ id: items, name: items }))
    } else if (field === 'shipOwners') {
      this.shipOwners = this.filters[field]?.map((items: any) => ({ id: items, name: items }))
    } else if (field === 'vslClass') {
      this.vslClasses = this.filters[field]?.map((items: any) => ({ id: items, name: items }))
    }
    console.log(this.distribution.shipOwner)
    this.showDropdown = false;
    this.applyFilters();

  }
  applyFilters() {
   
    const selectedSubpools = (this.subPools || []).map((s: any) => s.id.toLowerCase().trim());
    const selectedShips = (this.shipNames || []).map((s: any) => s.name.toLowerCase().trim());
    const selectedOwners = (this.shipOwners || []).map((s: any) => s.id.toLowerCase().trim());
    const selectedClasses = (this.vslClasses || []).map((s: any) => s.id.toLowerCase().trim());
    this.filteredShipPools = this.shipPools.map((subpool: any) => {
      const subpoolName = subpool.subpoolName.toLowerCase().trim();
      if (selectedSubpools.length > 0 && !selectedSubpools.includes(subpoolName)) {
        return null;
      }
      if (selectedShips.length === 0 && selectedOwners.length === 0 && selectedClasses.length === 0) {
        return subpool;
      }
      const matchedVessels = subpool.vesselsMonthlyData.filter((vessel: any) => {
        const vesselName = (vessel.vslName || '').toLowerCase().trim();
        const vesselOwner = (vessel.vslOwner || '').toLowerCase().trim();
        const vesselClass = (vessel.vslClass || '').toLowerCase().trim();
        return (
          (selectedShips.length === 0 || selectedShips.includes(vesselName)) &&
          (selectedOwners.length === 0 || selectedOwners.includes(vesselOwner)) &&
          (selectedClasses.length === 0 || selectedClasses.includes(vesselClass))
        );
      });
      if (matchedVessels.length === 0) return null;
      return { ...subpool, vesselsMonthlyData: matchedVessels };
    }).filter(Boolean);
    this.filteredShipPools = this.filteredShipPools.map((items: any) => {
      const upadtedOffhiring = items?.vesselsMonthlyData?.map((data: any) => {
        if (this.toggleVal !== 'Monthly') {
          this.offhiringCurrentMonth = this.getHiringMonth?.hasOffHireinCurrentMonth?.some((x: any) => x?.toString().toLowerCase() == data?.vslCodeOwner?.toString().toLowerCase());
          this.offHiringPreviousMonth = this.getHiringMonth?.hasOffHireinPreviousMonth?.filter((x: any) =>
            !(this.getHiringMonth?.hasOffHireinCurrentMonth || [])?.includes(x));
          this.offHiringPreviousMonth = this.offHiringPreviousMonth?.some((x: any) => x?.toString().toLowerCase() == data?.vslCodeOwner?.toString().toLowerCase());
          this.isPenaltyCurrentMonth = this.getHiringMonth?.hasPenaltyinCurrentMonth?.some((x: any) => x?.toString().toLowerCase() == data?.vslCodeOwner?.toString().toLowerCase());
          this.hasPoolPointUpdateinCurrentMonth = this.getHiringMonth?.hasPoolPointUpdateinCurrentMonth?.some((x: any) => x?.toString().toLowerCase() == data?.vslCodeOwner?.toString().toLowerCase());
          const penaltyPrevFiltered = this.getHiringMonth?.hasPenaltyinPreviousMonth?.filter(
            (x: any) => !(this.getHiringMonth?.hasPenaltyinCurrentMonth || []).includes(x)
          ) || [];
          const poolPointPrevFiltered = this.getHiringMonth?.hasPenaltyinPreviousMonth?.filter(
            (x: any) => !(this.getHiringMonth?.hasPoolPointUpdateinCurrentMonth || []).includes(x)
          ) || [];
          const combinedPrev = [...penaltyPrevFiltered, ...poolPointPrevFiltered];
          this.isPenaltyPreviousMonth = combinedPrev.some((x: any) => x?.toString().toLowerCase() === data?.vslCodeOwner?.toString().toLowerCase());
        } else {
          this.offhiringCurrentMonth = this.getHiringMonth?.hasOffHireinCurrentMonth?.some((x: any) => x?.toString().toLowerCase() == data?.vslCodeOwner?.toString().toLowerCase());
          this.isPenaltyCurrentMonth = this.getHiringMonth?.hasPenaltyinCurrentMonth?.some((x: any) => x?.toString().toLowerCase() == data?.vslCodeOwner?.toString().toLowerCase());
          this.hasPoolPointUpdateinCurrentMonth = this.getHiringMonth?.hasPoolPointUpdateinCurrentMonth?.some((x: any) => x?.toString().toLowerCase() == data?.vslCodeOwner?.toString().toLowerCase());
        }
        return data = {
          ...data, offHireCurrentMonth: this.offhiringCurrentMonth,
          offHirePreviousMonth: this.offHiringPreviousMonth,
          hasPenaltyinCurrentMonth: this.isPenaltyCurrentMonth,
          hasPenaltyinPreviousMonth: this.isPenaltyPreviousMonth,
          hasPoolPointUpdateinCurrentMonth: this.hasPoolPointUpdateinCurrentMonth
        }
      })
      return items = { ...items, vesselsMonthlyData: upadtedOffhiring };
    })
    console.log(this.filteredShipPools)
    this.filteredShipPools.some((item:any)=>{
      if(item?.overheadCharges !== null && item?.showScrubberSavings && item?.showLNGSavings && (item?.accountingVoyage !== null || item?.accountingVoyageMonthly !== null)){
        this.showOverHeadScrubberLNGVoyage = true;
      } 
    })
    this.grandTotal();
    
  }

  grandTotal() {
    this.grandTotalValues = {};
    this.completeGrandTotalValues = {};
    this.distributionColData?.forEach((header: any) => {
      const key = header.colHeaderYTD?.trim();
      //if (!header.hidden && key) {  //if its hiddent still we need value to calculate grancd total values
        this.grandTotalValues[key] = 0;
      //}
      if (key) {
        this.completeGrandTotalValues[key] = 0;
      }
    });
    const dataSource = (this.filteredShipPools && this.filteredShipPools.length > 0) ? this.filteredShipPools : this.shipPools;
    let count: number = 0;
    dataSource?.forEach((subpool: any) => {
      if (!subpool?.vesselsMonthlyData) return;
      subpool.vesselsMonthlyData.forEach((vessel: any) => {
        if (!vessel || typeof vessel !== 'object') return;
        this.distributionColData?.forEach((header: any) => {
          const key = header.colHeaderYTD?.trim();
          if (key && key in this.grandTotalValues && vessel[key] != null && typeof vessel[key] === 'number') {
            this.grandTotalValues[key] += vessel[key];
          }
          if (key && key in this.completeGrandTotalValues && vessel[key] != null && typeof vessel[key] === 'number') {
            this.completeGrandTotalValues[key] += vessel[key];
          }
        });
        count++;
      });
    });
    this.grandTotalValues['poolPoint'] = this.grandTotalValues['poolPoint'] / count;
    this.completeGrandTotalValues['poolPoint'] = this.completeGrandTotalValues['poolPoint'] / count;
    if (this.toggleValueChange && (this.shipNames?.length || this.shipOwners?.length || this.subPools?.length || this.vslClasses?.length)) {
      this.distributionColData?.forEach((header: any) => {
        const key = header.colHeaderYTD?.trim();
        if (key) {
          this.completeGrandTotalValues[key] = 0;
        }
      });
      let count: number = 0;
      this.shipPools?.forEach((subpool: any) => {
        if (!subpool?.vesselsMonthlyData) return;
        subpool.vesselsMonthlyData.forEach((vessel: any) => {
          if (!vessel || typeof vessel !== 'object') return;
          this.distributionColData?.forEach((header: any) => {
            const key = header.colHeaderYTD?.trim();
            if (key && key in this.completeGrandTotalValues && vessel[key] != null && typeof vessel[key] === 'number') {
              this.completeGrandTotalValues[key] += vessel[key];
            }
          });
          count++;
        });
      });
      this.completeGrandTotalValues['poolPoint'] = this.completeGrandTotalValues['poolPoint'] / count;
    }
    //YTD values
    this.grandTotalValues['poolInYTD'] = this.grandTotalValues['distAmtYTD'] / this.grandTotalValues['opDaysYTD'];
    this.completeGrandTotalValues['poolInYTD'] = this.completeGrandTotalValues['distAmtYTD'] / this.completeGrandTotalValues['opDaysYTD'];
    this.grandTotalValues['poolOutYTD'] = this.grandTotalValues['grossShareInPool'] / this.grandTotalValues['opDaysYTD'];
    this.completeGrandTotalValues['poolOutYTD'] = this.completeGrandTotalValues['grossShareInPool'] / this.completeGrandTotalValues['opDaysYTD'];
    this.grandTotalValues['netPoolOutPerOpdaysAmtYTD'] = this.grandTotalValues['netPoolOutYTD'] / this.grandTotalValues['opDaysYTD'];
    this.completeGrandTotalValues['netPoolOutPerOpdaysAmtYTD'] = this.completeGrandTotalValues['netPoolOutYTD'] / this.completeGrandTotalValues['opDaysYTD'];
    //monthly values
    this.grandTotalValues['poolIn'] = this.grandTotalValues['distAmt'] / this.grandTotalValues['opDays'];
    this.completeGrandTotalValues['poolIn'] = this.completeGrandTotalValues['distAmt'] / this.completeGrandTotalValues['opDays'];
    this.grandTotalValues['poolOut'] = this.grandTotalValues['grossShareInPoolAmt'] / this.grandTotalValues['opDays'];
    this.completeGrandTotalValues['poolOut'] = this.completeGrandTotalValues['grossShareInPoolAmt'] / this.completeGrandTotalValues['opDays'];
    this.grandTotalValues['netPoolOutPerOpdaysAmt'] = this.grandTotalValues['netPoolOut'] / this.grandTotalValues['opDays'];
    this.completeGrandTotalValues['netPoolOutPerOpdaysAmt'] = this.completeGrandTotalValues['netPoolOut'] / this.completeGrandTotalValues['opDays'];

    this.refreshDropdownData();
  }
  getTrimmedHeader(col: any): string {
    return (col?.colHeaderYTD || '').trim();
  }
  public resetDropdown(event: any, field: string) {
    if ((this.shipNames?.length && field === 'ship') || (this.subPools?.length && field === 'subpool') || (this.shipOwners?.length && field === 'shipOwners') || (this.vslClasses?.length && field === 'vslClass')) {
      this.filters[field] = [];
      this.distribution.distributionData = this._filterService.filterItems(this.distribution.allDistributionData, this.filters);
      this.refreshDropdownData();
      if (field === 'ship') {
        this.shipNames = [];
      } else if (field === 'subpool') {
        this.subPools = [];
      } else if (field === 'shipOwners') {
        this.shipOwners = [];
      } else if (field === 'vslClass') {
        this.vslClasses = [];
      }
      this.showDropdown = false;
      this.applyFilters();
    }
  }

   public selectedDate(event: any) {
    this.dateSelected = event;
    this.hideDefaultUsersettigs = true;
    this._distributionDataService.changeMonthYear.next(event);
    this._distributionDataService.setSelectedMonthYearVal(event);
    this.shipNames = [];
    this.subPools = [];
    this.shipOwners = [];
    this.vslClasses = [];
    this.filters.ship = [];
    this.filters.shipOwners = [];
    this.filters.subpool = [];
    this.filters.vslClass = [];
    let selectDate = new Date(event);
    if(this.selectedPagetab === 'dist'){
     
      this.getDistributionVessel(selectDate.getFullYear(), selectDate.getMonth() + 1);
      this.distribution.selectDate = { month: selectDate.getMonth() + 1, year: selectDate.getFullYear() }
    }
  }

  public refreshDropdownData() {
    if (this.distribution.owners?.length) {
      if (this.filters.ship['selectedRecords']?.length) {
        this.filters.ship = this.filters.ship['selectedRecords'].map((record: any) => record.name);
      }
      if (this.filters.shipOwners['selectedRecords']?.length) {
        this.filters.shipOwners = this.filters.shipOwners['selectedRecords'].map((record: any) => record.id);
      }
      console.log("this.FleetList.shipowners",this.distribution.shipOwner )
      console.log("this.FleetList.owners",this.distribution.owners )
      console.log(this.filters)
      this.distribution.shipOwner = this._filterService.shipOwners(this.distribution.allDistributionData, this.filters, this.distribution.owners);
      this.distribution.shipOwner = this.distribution.shipOwner.filter((obj: any, index: any, self: any) => index === self.findIndex((x: any) => x.id === obj.id));
      console.log("this.FleetList.shipowners2",this.distribution.shipOwner )
    }
    if (this.filters.subpool['selectedRecords']?.length) {
      this.filters.subpool = this.filters.subpool['selectedRecords'].map((record: any) => record.name);
    }
    if (this.filters.vslClass?.['selectedRecords']?.length) {
      this.filters.vslClass = this.filters.vslClass['selectedRecords'].map((record: any) => record.id);
    }
    if (!this.filters.subpool?.length || this.filters.subpool?.length === undefined) {
      this.filters.subpool = [];
    }
    if (!this.filters.ship?.length || this.filters.ship?.length === undefined) {
      this.filters.ship = [];
    }
    if (!this.filters.shipOwners?.length || this.filters.shipOwners?.length === undefined) {
      this.filters.shipOwners = [];
    }
    if (!this.filters.vslClass?.length || this.filters.vslClass?.length === undefined) {
      this.filters.vslClass = [];
    }
    console.log("all1",this.filters)
    this.distribution.ship = this._filterService.ships(this.distribution.allDistributionData, this.filters);
    this.distribution.subpool = this._filterService.subpools(this.distribution.allDistributionData, this.filters);
    this.distribution.subpool = this.distribution.subpool.filter((obj: any, index: any, self: any) => index === self.findIndex((x: any) => x.id === obj.id));
    this.distribution.vslClass = this._filterService.vslClass(this.distribution.allDistributionData, this.filters);
    this.distribution.vslClass = this.distribution.vslClass.filter((obj: any, index: any, self: any) => index === self.findIndex((x: any) => x.id === obj.id));
  }

  public resetAll() {
    let filters = ['ship', 'shipOwners', 'subpool', 'vslClass'];
    filters.forEach((it: any) => {
      this.filters[it] = [];
    });
    this.distribution.distributionData = this._filterService.filterItems(this.distribution.allDistributionData, this.filters);
    this.refreshDropdownData();
    this.shipNames = [];
    this.shipOwners = [];
    this.subPools = [];
    this.vslClasses = [];
    this.showDropdown = false;
    this.applyFilters();
  }

  public resetActivate() {
    return (this.filters['ship'].length > 0 || this.filters['shipOwners'].length > 0 || this.filters['subpool'].length > 0 || this.filters['vslClass'].length > 0) ? true : false;
  }

  public checkBox(vslNumber: string) {
    if (this.filters['vslNumber'].includes(vslNumber) || this.distribution.allSelect) {
      return true;
    }
    else {
      return false;
    }
  }

  getModaldata() {
    // ---for disabling button
    this.checkColumnLength = [];
    // -----
    this._distributionDataService.userLoggedEmail.subscribe((res: any) => {
      if (res) {
        this.emailRequset.email = res;
        this._distributionDataService.getDistributionModalData(this.emailRequset).subscribe({
          next: (res: any) => {
            if (res?.data) {
              this.distributionModalData = res?.data;
              this.getModalDataDateChange();
            }
          },
          error: (error: any) => {
            this.toasterService.openToast('Error', error);
          }
        })
      }
    })
  }
  getModalDataDateChange(){
    this.userEmailid = this.distributionModalData?.getUserDefaultSettings?.data?.email;
    this.resetToDefault = this.distributionModalData?.getUserDefaultSettings?.enableReset;
    // ---for disabling button
    this.checkColumnLength = this.distributionModalData?.getUserDefaultSettings?.data?.columns;
    // ------
    this.distributionColData = this.distributionModalData?.getUserDefaultSettings?.data?.columns;
    console.log(this.distributionColData)
    this.toggleVal = this.distributionModalData?.getUserDefaultSettings?.data?.toggleType;
    if (this.toggleVal === 'Monthly') {
      this.distributionColData = this.distributionColData?.map((items: any) => ({ name: items?.name, value: items?.value, sequence: items?.sequence, hidden: items?.hidden, colHeaderYTD: items?.monthly?.trim() })).filter((data: any) => data?.hidden !== null);
      this.defaultActive = false;
    } else {
      this.distributionColData = this.distributionColData?.map((items: any) => ({ name: items?.name, value: items?.value, sequence: items?.sequence, hidden: items?.hidden, colHeaderYTD: items?.YTD.trim() })).filter((data: any) => data?.hidden !== null);
      this.defaultActive = true;
    }
    console.log(this.distributionColData)
    this.distributionColData = this.distributionColData?.sort((a: any, b: any) => a.sequence - b.sequence)
    this.tableHeaderdata = [...this.distributionColData];
    this.tableHeaderdata?.unshift({ name: 'Ship / Ship owner', value: 'shipOwner' });
    this.tableHeaderdata = this.tableHeaderdata?.sort((a: any, b: any) => a.sequence - b.sequence)
    if(this.tableHeaderdata?.length){
      setTimeout(() => {
        this.getTableOffsetWidth();
      }, 0);
    }
    this.newtableHeaderdata = this.tableHeaderdata
    this.enableApplybtn = false;
    if (this.distributionColData?.some((items: any) => items?.hidden)) {
      this.showDownloadFilter = true;
    } else {
      this.showDownloadFilter = false;
    }
    this.applyFilters();
    if (!this.defaultGrandtotalset || this.dateSelected) {
      this.defaultGrandTotalValues = JSON.parse(JSON.stringify(this.completeGrandTotalValues));
      this.defaultGrandtotalset = true;
    }
    if (this.defaultGrandTotalValues && typeof this.defaultGrandTotalValues === 'object' && Object.keys(this.defaultGrandTotalValues).length > 0) {
      const reorderdefaultGrandTotalValues = {}
      this.tableHeaderdata.forEach((items: any) => {
        const key = items.colHeaderYTD;
        if (key) {
          reorderdefaultGrandTotalValues[key] = this.defaultGrandTotalValues[key] ?? '';
        }
        let showTooltipArray: string[] = ['poolInPerOpDaysAmt', 'relShare', 'grossDistribution', 'poolOut', 'overheadFee', 'commissionFee', 'bunkerFee', 'managementFee', 'netPoolOut', 'netPoolOutPerOpDaysAmt', 'profitShare', 'finalPayout'];
        items.showTooltip = false;
        if (showTooltipArray.includes(items.value)) { // tool tip availbale for few data not all, so adding that flag here
          items.showTooltip = true;
        }
        if (items.value === 'finalPayout') {
          //final payout should be visible only On the Monthly view
          this.showFinalPayout = false;
          if (this.toggleVal === 'Monthly' && !items.hidden) {
            this.showFinalPayout = true;
            this.calcDistributionColDataLength = this.distributionColData?.filter((item:any)=>!item?.hidden).length;
            console.log("calcDistributionColDataLength",this.calcDistributionColDataLength)
          }else{
            this.calcDistributionColDataLength = this.distributionColData?.filter((item:any)=>!item?.hidden).length - 1;
            console.log("calcDistributionColDataLength",this.calcDistributionColDataLength)
          }
          
        }
      })
      this.defaultGrandTotalValues = reorderdefaultGrandTotalValues;
    }
  }
  showColumn(columnName) {
    if (columnName === 'finalPayout') {
      if (this.toggleVal === 'YTD') {
        return false;
      }
      else {// monthly
        return this.showFinalPayout;
      }
    }
    return true
  }
  trackByIndex(index: number, item: any): string {
    return item?.value;
  }
  allowDrop(event: DragEvent): void {
    event.preventDefault();
    event.dataTransfer!.dropEffect = 'move';
  }
  drag(index: number): void {
    this.dragStartindex = index;
    this.isDragging = true;
  }
  drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex === event.currentIndex) return;
    moveItemInArray(this.distributionColData, event.previousIndex, event.currentIndex);
    this.distributionColData.forEach((item: any, i: any) => item.sequence = i + 1);
    this.dragStartindex = null;
    this.isDragging = false;
    this.enableApplybtn = true;
    this.cdr.detectChanges();
  }
  
  trackByValue(index: number, item: any) {
    return item.value;
  }
  selectShipname(data: any) {
    data.hidden = !data.hidden;
    if (data.hidden) {
      this.storeDistributionModalData.push(data);
      if (this.storeDistributionModalData?.length) {
        this.storeCheckedvalue = [];
      }
    } else {
      this.storeDistributionModalData = this.storeDistributionModalData.filter((items: any) => items?.value !== data.value);
      this.storeCheckedvalue.push(data);
      if (this.storeCheckedvalue?.length) {
        this.storeDistributionModalData = [];
      }
    }
  }
  applyModalUpdataData() {
    document.body.style.overflow = 'auto'; //to solve scroll issue after closing customise popup
    let distributionColdata = this.distributionColData?.map((items: any) => ({ name: items?.name, value: items?.value, sequence: items?.sequence, hidden: items?.hidden }));
    let updateModalobj = {
      "email": this.emailRequset?.email,
      "module": "Distribution",
      "toggleType": this.toggleVal,
      "columns": distributionColdata
    }
    this._distributionDataService.updateDistributionModalData(updateModalobj).subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.updateModaldata = res?.data?.upsertUserSetting;
          this.distributionColData = this.updateModaldata?.data?.columns;
          this.getModaldata();
          this.open = false;
          this.storeDistributionModalData = [];
          this.storeCheckedvalue = [];
          this.resetToDefault = this.updateModaldata?.enableReset;
        }
      },
      error: (error: any) => {
        this.toasterService.openToast("Error", error);
      }
    })

  }
  reset() {
    document.body.style.overflow = 'auto'; //to solve scroll issue after closing customise popup
    let updateModalobj = {
      "email": this.emailRequset?.email,
      "module": "Distribution",
      "toggleType": this.toggleVal,
      "columns": []
    }
    this._distributionDataService.updateDistributionModalData(updateModalobj).subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.getModaldata();
          // this.distributionModalData = res?.data?.upsertUserSetting?.data?.columns;
          // this.getModalDataDateChange();
          this.open = false;
          this.storeDistributionModalData = [];
          this.storeCheckedvalue = [];
          this.resetToDefault = this.updateModaldata?.enableReset;
        }
      },
      error: (error: any) => {
        this.toasterService.openToast("Error", error);
      }
    })
  }
  cancel() {
    this.open = false;
    //this.getModaldata();
    this.getModalDataDateChange();
    this.storeDistributionModalData = [];
    this.storeCheckedvalue = [];
    document.body.style.overflow = 'auto'; //to solve scroll issue after closing customise popup
    // this.resetHeaderconfig = [...this.shipheaderConfig];
    // this.distributionColData = this.distributionColData.sort((a: any, b: any) => a.sequence - b.sequence)
  }
  getYtdMonthlyVal(e: any) {
    this.showFinalPayout = false;
    this.toggleVal = e?.itemName;
    // this.getModaldata();
    this.toggleValueChange = e?.itemName;
    this.defaultGrandtotalset = false;
    if (e?.itemName === "Monthly") {
      this.showFinalPayout = true;
    }
    this.applyModalUpdataData();
  }

  getCalculationEvent(shipDeatils: any) {
    this._googleAnaylticsService.triggerGTMEvent(GoogleAnalyticsEvents.OPEN_SHIP_SIDE_PANEL,{module:GoogleAnalyticsModules.DISTRIBUTION});
    //this.isCalculationOpen = false; //if side panel is open and user click on other ship then without closing data will get updated
    this.isCalculationOpen = true;
    this.calculationSidePanelHeaderName = shipDeatils?.vslName;
    this.calculationResponse = [];
    let calculationObj = {
      "vslCode": shipDeatils?.vslCode,
      "vslCodeOwner": shipDeatils?.vslCodeOwner,
      "month": this.latestMonth,
      "year": this.latestYear,
      "fleet": shipDeatils?.fleet
    }
    this._distributionDataService.GetDistributionVesselCalculation(calculationObj).subscribe({
      next: (res: any) => {
        if (res?.data?.getDistributionVesselCalculation?.statusCode === 200 && res?.data?.getDistributionVesselCalculation?.success) {
          this.calculationResponse = res?.data?.getDistributionVesselCalculation?.distributionVesselCalculation;
          // this.isCalculationOpen = true;
          // this.calculationSidePanelHeaderName = this.calculationResponse[0].vslName;
        }
        else {
          this.toasterService.openToast('Error', res?.data?.getDistributionVesselCalculation?.message)
        }
      },
      error: (error: any) => {
        this.toasterService.openToast('Error', error)
      }
    })
  }

  getoffHireEvent(data: any) {
    this.offHireShipName = data?.vslName;
    this.offHireData = [];
    this.isCalculationOpen = false;
    let offHireobj = {
      "vslCode": data?.vslCode,
      "vslCodeOwner": data?.vslCodeOwner,
      "month": this.latestMonth,
      "year": this.latestYear,
      "toggleType": this.toggleVal
    }
    this._distributionDataService.getOffhireEventData(offHireobj).subscribe({
      next: (res: any) => {
        this.offHireData = res?.data?.getOffhireEvents?.data;
      },
      error: (error: any) => {
        this.toasterService.openToast("Error", error);
      }
    })
  }
  getPoolPointsModalData(data: any){
    this.poolPointShipName = data?.vslName;
    this.poolPointsData = [];
    this.isCalculationOpen = false;
    let poolPointObj = {
      "vslCode": data?.vslCode,
      "vslCodeOwner": data?.vslCodeOwner,
      "month": this.latestMonth,
      "year": this.latestYear,
      "toggleType": this.toggleVal,
      // "currentViewedMonth":this.latestMonth,
      // "currentViewedYear":this.latestYear
    }
    this._distributionDataService.getPoolPointsEventData(poolPointObj).subscribe({
      next: (res: any) => {
        this.poolPointsData = res?.data?.getPoolPointChanges?.data;
      },
      error: (error: any) => {
        this.toasterService.openToast("Error", error);
      }
    })
  }
  generatePdf(checkBooleanval: boolean) {
    const doc = new jsPDF('l', 'mm', [210, 297]);
    let y = 10;
    doc.setLineWidth(1);
    doc.setFontSize(16);
    if (this.selectedPagetab === 'dist') {
      if (this.toggleVal === 'YTD') {
        doc.text("Distribution (YTD)", 140, y);
      } else {
        doc.text("Distribution (Monthly)", 140, y);
      }
    } else if (this.selectedPagetab === 'scrubber') {
      if (this.toggleVal === 'YTD') {
        doc.text("Scrubber (YTD)", 140, y);
      } else {
        doc.text("Scrubber (Monthly)", 140, y);
      }
    }else{
       if (this.toggleVal === 'YTD') {
        doc.text("LNG (YTD)", 140, y);
      } else {
        doc.text("LNG (Monthly)", 140, y);
      }
    }
    doc.setFontSize(12);
    y += 5;
    doc.text("Time Period : " + this.monthNameArray[this.distribution.selectMonth - 1] + ' ' + this.distribution.selectYear, 250, y);
    if (this.selectedPagetab === 'dist') {
      this.tableHeaderdata = this.tableHeaderdata.filter((h:any) => h.name !== 'Pool');
      this.newtableHeaderdata = this.newtableHeaderdata.filter((h:any) => h.name !== 'Pool');
       this.showVisibleHaeders = checkBooleanval ?[...this.newtableHeaderdata] : this.tableHeaderdata?.filter((x: any) => !x.hidden);
      console.log( this.showVisibleHaeders)
      if(this.toggleVal !== 'Monthly'){
        this.showVisibleHaeders =  this.showVisibleHaeders?.filter((items:any)=>items?.value !== "finalPayout")
        console.log("visibleHeaders1",this.showVisibleHaeders)
      }
      
      const shipOwnerIndex =  this.showVisibleHaeders.findIndex((h:any) => h.name === 'Ship / Ship owner');
      if(shipOwnerIndex !== -1) {
         this.showVisibleHaeders.splice(shipOwnerIndex, 1,
          { name: 'Ship owner', colHeaderYTD: 'vslOwner' },
          { name: 'Ship', colHeaderYTD: 'vslName' },    
        );
      }
       this.showVisibleHaeders.unshift({ name: 'Pool', value: 'pool' });
      this.head = [ this.showVisibleHaeders.map((header: any) => header.name)];
      this.body = [];
      let dataSource = checkBooleanval ? this.shipPools : this.filteredShipPools;
      if (dataSource?.length > 0) {
        dataSource?.forEach((pool: any) => {
          const vessels = pool.vesselsMonthlyData || [];
          vessels.forEach((vessel: any) => {
            const row: any[] = [];
             this.showVisibleHaeders.forEach(header => {
              if(header.name === 'Pool'){
                row.push(`${vessel.subPool || ''}`)        
              }
              else if (header.name === 'Ship owner') {
                row.push(`${this.ownersLabel[vessel.vslOwner] || ''}`);
              }
              else if (header.name === 'Ship') {
                // row.push(vessel.vslName && vessel.vslOwner || '');
                row.push(`${vessel.vslName || ''}`);
              } 
              else {
                const key = header.colHeaderYTD;
                if (key === 'profitSharingContrAmt' || key === 'profitSharingContrAmtYTD') {
                  const val = vessel.hasOwnProperty(key) ? vessel[key] : '';
                  if (val === 0 && !vessel?.isElegibleForProfitSharing) {
                    row.push('N/A');
                  } else {
                    if(this.toggleVal !== 'Monthly' || this.distribution.selectDate.month == 5 || this.distribution.selectDate.month == 11){
                      row.push(this.negativeToBracket.transform(val));
                    }
                    else{
                      row.push('N/A');
                    }
                  }
                } else {
                  row.push(key && vessel.hasOwnProperty(key) ? this.negativeToBracket.transform(vessel[key]) : '');
                }
              }
            });
            this.body.push(row);
          });
        });
      }
      const grandTotalRow: any[] = [];
       this.showVisibleHaeders.forEach((header: any) => {
        // if (header.name === 'Pool') {
        //   // grandTotalRow.push('Total');
        // }
        // else if (header.name === 'Ship owner') {
        //   grandTotalRow.push('N/A');
        // }
        // else if (header.name === 'Ship') {
        //   grandTotalRow.push('Total');
        // }
        if (header.name === 'Ship') {
          grandTotalRow.push('Total');
        } else {
          const key = header.colHeaderYTD;
          /* if (key === 'poolPoint') {
            grandTotalRow.push('N/A');
          }
          else{ */
            const totalValue = checkBooleanval ? (key && this.defaultGrandTotalValues?.[key]) : (key && this.grandTotalValues?.[key]);
            if (key === 'profitSharingContrAmt' || key === 'profitSharingContrAmtYTD') {
              if(this.toggleVal !== 'Monthly' || this.distribution.selectDate.month == 5 || this.distribution.selectDate.month == 11){
                grandTotalRow.push(typeof totalValue === 'number' ? this.negativeToBracket.transform(totalValue) : '');
              }
              else{
                grandTotalRow.push('N/A');
              }
            }
            else{
              // const totalValue = key && (checkBooleanval ? (this.dateSelected ? this.completeGrandTotalValues?.[key] : this.defaultGrandTotalValues?.[key]) : this.completeGrandTotalValues?.[key]);
              grandTotalRow.push(typeof totalValue === 'number' ? this.negativeToBracket.transform(totalValue) : '');
            }
          //}          
        }
      });
      this.body.push(grandTotalRow);
    } else if (this.selectedPagetab === 'scrubber') {
      this.head = [['Pool','Ship owner', 'Ship ', 'Scrubber days', 'Scrubber points', 'Scrubber savings($)']];
      this.body = [];
      let dataSource = [];
      dataSource = checkBooleanval ? this.getScrubberDatalist : this.filterdScrubberList;
      dataSource.forEach((scrubberData: any) => {
        this.body.push([
          `${scrubberData.subPool || ''}`,
          `${this.ownersLabel[scrubberData.vslOwner] || ''}`, 
          `${scrubberData.vslName || ''} `,   
          this.toggleVal === 'YTD' ? this.negativeToBracket.transform(scrubberData.scbrDaysYTD) : this.negativeToBracket.transform(scrubberData.scbrDays),
          this.negativeToBracket.transform(scrubberData.scbrPoints),
          this.toggleVal === 'YTD' ? this.negativeToBracket.transform(scrubberData.scbrSavingsAmtYTD) : this.negativeToBracket.transform(scrubberData.scbrSavingsAmt)
        ]);
      });
    }else{
      this.head = [['Pool','Ship owner', 'Ship ','Operating Days', 'LNG savings($)']];
      this.body = [];
      let dataSource = [];
      dataSource = checkBooleanval ? this.getLngDatalist : this.filterdLngList;
      dataSource.forEach((lngData: any) => {
        this.body.push([
          `${lngData.subPool || ''}`,
          `${this.ownersLabel[lngData.vslOwner] || ''}`,
          `${lngData.vslName || ''}` ,
          this.toggleVal === 'YTD' ? this.negativeToBracket.transform(lngData.opDaysYTD) : this.negativeToBracket.transform(lngData.opDays),
          // this.negativeToBracket.transform(scrubberData.scbrPoints),
          this.toggleVal === 'YTD' ? this.negativeToBracket.transform(lngData.lngSavingsAmtYTD) : this.negativeToBracket.transform(lngData.lngSavingsAmt)
        ]);
      });
    }
    autoTable(doc, {
      head: this.head,
      body: this.body,
      startY: 20,
      margin: { top: 10, right: 3, bottom: 10, left: 3 },
      theme: 'grid',
      headStyles: {
        lineWidth: 0.5,
        fillColor: [211, 211, 211],
        textColor: '#27364B',
      },
      styles: {
        halign: 'center',
        fontSize: 5.6,
      },
      columnStyles: {
        0: { cellWidth: 23 },
      },
      didParseCell: (data) => {
        if (this.selectedPagetab === 'dist') {
          const rowIndex = data.row.index;
          const isGrandTotalRow = rowIndex === this.body.length - 1;
          if (isGrandTotalRow) {
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.fillColor = [230, 230, 230];
            data.cell.styles.textColor = [0, 0, 0];
          }
        }
      }
    });
    let filename: any;
    if (this.selectedPagetab === 'dist') {
      filename = `${this.monthNameArray[this.distribution.selectMonth - 1].toUpperCase()}-${this.distribution.selectYear.toString().slice(-2)}_Distribution.pdf`;
    } else if (this.selectedPagetab === 'scrubber') {
      filename = `${this.monthNameArray[this.distribution.selectMonth - 1].toUpperCase()}-${this.distribution.selectYear.toString().slice(-2)}_Scrubber.pdf`;
    }else{
      filename = `${this.monthNameArray[this.distribution.selectMonth - 1].toUpperCase()}-${this.distribution.selectYear.toString().slice(-2)}LNG.pdf`;
    }
    if (this.distribution.download) {
      doc.save(filename);
    }
    return filename;
  }


  exportExcelCSV(checkBooleanVal: boolean) {
    const workbook = new Workbook();
    
    if (this.selectedPagetab === 'dist') {
      this.worksheet = this.toggleVal === 'YTD' ? workbook.addWorksheet('Distribution YTD') : workbook.addWorksheet('Distribution Monthly');
      const isYTD = this.toggleVal === 'YTD';
      this.newtableHeaderdata = this.newtableHeaderdata.filter((h:any) => h.name !== 'Pool');
      this.tableHeaderdata = this.tableHeaderdata.filter((h:any) => h.name !== 'Pool');
      this.showBaseHeaders = checkBooleanVal ? [{name:'Pool',value:'pool'},...this.newtableHeaderdata] : [{name:'Pool',value:'pool'},...this.tableHeaderdata].filter((h: any) => !h?.hidden);
      console.log("this.showBaseHeaders",this.showBaseHeaders)
      if(this.toggleVal !== 'Monthly'){
        this.showBaseHeaders = this.showBaseHeaders?.filter((items:any)=> items?.value !== "finalPayout")
      }
      const expandedHeaders = this.showBaseHeaders.flatMap((h: any) => {
        if (h.name === 'Ship / Ship owner') {
          return [
            { ...h, name: 'Ship owner' },
            { ...h, name: 'Ship' }
            
          ];
        }
        return [h];
      });
      const headers = expandedHeaders.map((h: any) => `${h.name} (${isYTD ? 'YTD' : 'Monthly'})`);
      const headerRow = this.worksheet.addRow(headers);
      this.styleHeaderRow(headerRow);
      const dataSource = checkBooleanVal ? this.shipPools : this.filteredShipPools;
      const excelTableHeader = (!checkBooleanVal ? [{name:'Pool',value:'pool'},...this.tableHeaderdata]?.filter((x: any) => !x.hidden) :
      [{name:'Pool',value:'pool'},...this.newtableHeaderdata]).flatMap((h: any) => {
        if (h.name === 'Ship / Ship owner') {
          return [
            { name: 'Ship owner', value: h.value, colHeaderYTD: h.colHeaderYTD },
            { name: 'Ship', value: h.value, colHeaderYTD: h.colHeaderYTD }        
          ];
        }
        return [h];
      });
      dataSource.forEach((pool: any) => {
        const vessels = pool.vesselsMonthlyData || [];
        vessels.forEach((vessel: any) => {
          // console.log("this.newtableHeaderdata",this.tableHeaderdata)
          // console.log("this.tableHeaderdata",excelTableHeader)
          const rowValues = excelTableHeader.map((header: any) => {
            if (header.name === 'Pool') {
            return `${vessel.subPool || ''}`
            }
            else if(header.name === 'Ship owner'){
              return `${this.ownersLabel[vessel.vslOwner] || ''}`
            }
            else if (header.name === 'Ship') {
              return `${vessel.vslName || ''} `;
            }
             else {
              const key = header.colHeaderYTD;
              if (key === 'profitSharingContrAmt' || key === 'profitSharingContrAmtYTD') {
                const val = vessel.hasOwnProperty(key) ? vessel[key] : '';
                if (val === 0 && !vessel?.isElegibleForProfitSharing) {
                  return 'N/A'
                } else {
                  if(this.toggleVal !== 'Monthly' || this.distribution.selectDate.month == 5 || this.distribution.selectDate.month == 11){
                    return val;
                  }
                  else{
                    return 'N/A';
                  }
                }
              } else {
                return key && vessel.hasOwnProperty(key) ? vessel[key] : '';
              }
            }
          });
          this.worksheet.addRow(rowValues);
        });
      });
      const grandTotalRowValues = excelTableHeader.map((header: any, idx: any) => {
        if (idx === 2) return 'Total';
        const key = header.colHeaderYTD;
        let grandTotalvaluesDefault: any;
       
        if (key) {
          grandTotalvaluesDefault = +((checkBooleanVal ? this.defaultGrandTotalValues[key] : this.grandTotalValues[key]).toFixed(2));
          /* if (key === 'poolPoint') {
            grandTotalvaluesDefault = 'N/A'
          } */
          if (key === 'profitSharingContrAmt' || key === 'profitSharingContrAmtYTD') {
            if(this.toggleVal !== 'Monthly' || this.distribution.selectDate.month == 5 || this.distribution.selectDate.month == 11){
              grandTotalvaluesDefault = +((checkBooleanVal ? this.defaultGrandTotalValues[key] : this.grandTotalValues[key]).toFixed(2));
            }
            else{
              grandTotalvaluesDefault = 'N/A'
            }
          }
          if(key === 'relShareYTD'){
            grandTotalvaluesDefault = checkBooleanVal ? this.defaultGrandTotalValues[key] : this.grandTotalValues[key];
          }
        } else {
          grandTotalvaluesDefault = ''; 
        }
        return grandTotalvaluesDefault;
      });
      const totalRow = this.worksheet.addRow(grandTotalRowValues);
      totalRow.eachCell((cell: any) => {
        cell.font = { bold: true, color: { argb: 'FF27364B' } };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFD3D3D3' }
        };
      });
    } else if (this.selectedPagetab === 'scrubber') {
      this.worksheet = this.toggleVal === 'YTD' ? workbook.addWorksheet('Scrubber YTD') : workbook.addWorksheet('Scrubber Monthly');
      const isYTD = this.toggleVal === 'YTD';
      const headers = [`Pool (${isYTD ? 'YTD' : 'Monthly'})`, `Ship owner (${isYTD ? 'YTD' : 'Monthly'}) `,`Ship (${isYTD ? 'YTD' : 'Monthly'}) `, `Scrubber days (${isYTD ? 'YTD' : 'Monthly'})`, `Scrubber points (${isYTD ? 'YTD' : 'Monthly'})`, `Scrubber savings($) (${isYTD ? 'YTD' : 'Monthly'})`];
      const headerRow = this.worksheet.addRow(headers);
      this.styleHeaderRow(headerRow);
      let dataSource = this.getScrubberDatalist || [];
      dataSource = checkBooleanVal ? this.getScrubberDatalist : this.filterdScrubberList;
      const scrubberRows = dataSource.map((scrubberData: any) => [
        `${scrubberData.subPool}`,
        `${this.ownersLabel[scrubberData.vslOwner]} `,
        `${scrubberData.vslName} `, 
        this.toggleVal === 'YTD' ? scrubberData.scbrDaysYTD : scrubberData.scbrDays,
        scrubberData.scbrPoints,
        this.toggleVal === 'YTD' ? scrubberData.scbrSavingsAmtYTD : scrubberData.scbrSavingsAmt
      ]);
      scrubberRows.forEach((row: any) => this.worksheet.addRow(row));
    }else{
      this.worksheet = this.toggleVal === 'YTD' ? workbook.addWorksheet('LNG YTD') : workbook.addWorksheet('LNG Monthly');
      const isYTD = this.toggleVal === 'YTD';
      const headers = [`Pool (${isYTD ? 'YTD' : 'Monthly'})`, ` Ship owner (${isYTD ? 'YTD' : 'Monthly'})`,` Ship (${isYTD ? 'YTD' : 'Monthly'})`, `Operating days (${isYTD ? 'YTD' : 'Monthly'})`, `LNG savings($) (${isYTD ? 'YTD' : 'Monthly'})`];
      const headerRow = this.worksheet.addRow(headers);
      this.styleHeaderRow(headerRow);
      let dataSource = this.getLngDatalist || [];
      dataSource = checkBooleanVal ? this.getLngDatalist : this.filterdLngList;
      const scrubberRows = dataSource.map((lngData: any) => [
        `${lngData.subPool}`,
        `${this.ownersLabel[lngData.vslOwner]} `,
        `${lngData.vslName} `,
        this.toggleVal === 'YTD' ? lngData.opDaysYTD : lngData.opDays,
        this.toggleVal === 'YTD' ? lngData.lngSavingsAmtYTD : lngData.lngSavingsAmt
      ]);
      scrubberRows.forEach((row: any) => this.worksheet.addRow(row));
    }
    this.worksheet.columns.forEach((col: any) => {
      let maxLength = 10;
      (col as any).eachCell({ includeEmpty: true }, (cell: any) => {
        const cellValue = cell.value ? cell.value.toString() : '';
        if (cellValue.length > maxLength) {
          maxLength = cellValue.length;
        }
      });
      col.width = maxLength + 2;
    });
    let filename: any;
    if (this.selectedPagetab === 'dist') {
      filename = `${this.monthNameArray[this.distribution.selectMonth - 1].toUpperCase()}-${this.distribution.selectYear.toString().slice(-2)}_Distribution.xlsx`;
    } else if (this.selectedPagetab === 'scrubber') {
      filename = `${this.monthNameArray[this.distribution.selectMonth - 1].toUpperCase()}-${this.distribution.selectYear.toString().slice(-2)}_Scrubber.xlsx`;
    }else{
      filename = `${this.monthNameArray[this.distribution.selectMonth - 1].toUpperCase()}-${this.distribution.selectYear.toString().slice(-2)}_LNG.xlsx`;
    }
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      if (this.distribution.download) {
        saveAs(blob, filename);
      }
    });
  }

  styleHeaderRow(row: any): void {
    row.eachCell((cell: any) => {
      cell.font = { bold: true, color: { argb: 'FF27364B' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD3D3D3' }
      };
      cell.alignment = { horizontal: 'center' };
    });
  }
  clickTab(val: any) {
    this.hideDefaultUsersettigs = false;
    this._distributionDataService.setSelectedPagetabVal(val);
    this.selectedPagetab = val;
    this.showDropdown = false;
    if(val === 'dist'){
      // this.shipNames = [];
      // this.subPools = [];
      // this.shipOwners = [];
      if(this._distributionDataService.getSelectedMonthYearVal() !== ''){
        let selectedDate = new Date(this._distributionDataService.getSelectedMonthYearVal());
        this.getDistributionVessel(selectedDate.getFullYear(), selectedDate.getMonth() + 1);
      //  setTimeout(() => {
        // this.getModaldata();
      //  }, 3000); 
        this.distribution.selectDate = { month: selectedDate.getMonth() + 1, year: selectedDate.getFullYear() } 
      }   
    }
  }
  dropDownlist() {
    this.showDropdown = !this.showDropdown;
  }
  getScrubberdata(data: any) {
    this.getScrubberDatalist = data?.allData ? data?.allData : data;
    this.filterdScrubberList = data?.filteredData;
    this._distributionDataService.filterdScrubberListdata = this.filterdScrubberList;
  }
   getLngdata(data: any) {
    this.getLngDatalist = data?.allData ? data?.allData : data;
    this.filterdLngList = data?.filteredData;
    this._distributionDataService.filterdLngListdata = this.filterdLngList;
  }
  getToggleval(e: any) {
    this.toggleVal = e;
  }
  showDropdownVal(e: boolean) {
    this.showDropdown = e;
  }
  showBannertoggle() {
    this._distributionDataService.getBannerDisplay().subscribe({
      next: (res: any) => {
        if (res?.data?.getLogicAppRunHistoryFun?.data !== null) {

          this.showBannerToggleDisplay = res?.data?.getLogicAppRunHistoryFun?.data;
          let lastRunDate = new Date(this.showBannerToggleDisplay?.startTime)
          this.getBannerlastRunDate = lastRunDate.toString();
          let currentDate = new Date();
          this.previousMonth = new Date(0, currentDate.getMonth() - 1).toLocaleString('en-US', { month: 'long' });
          /* this.currentDate = new Date(0, currentDate.getMonth()).toLocaleString('en-US', { month: 'long' });
          this.currentYear = currentDate.getFullYear(); */
          const firstDate = new Date(new Date().getFullYear(), new Date().getMonth(), SHOW_BANNER_START_DAY);
          this.calculationDate = new Date(new Date().getFullYear(), new Date().getMonth(), CALCULATION_SCHEDULE_DAY);
          
          if (currentDate > firstDate && currentDate < this.calculationDate) {
            this.showBannerToggleVal = true;
          }
          else if (lastRunDate >= this.calculationDate && this.showBannerToggleDisplay?.status.trim().toLowerCase() === "succeeded") {
            this.showBannerToggleVal = false;
          }
          else {
            this.showBannerToggleval_ = true;
          }
        }
      },
      error: (error: any) => {
        this.toasterService.openToast("Error", error);
      }
    })
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  
  triggerGTMEvent(eventName: string, data?:any) {
    this._googleAnaylticsService.triggerGTMEvent(eventName, data);
  }
}
